module.exports = __webpack_public_path__ + "img/monitor.6c22d932.png";